import Keycloak from 'keycloak-js'
import {
  createMockKeycloak,
  hasMockAuthCookie,
} from '~/helpers/mockKeycloakIdentity'
import { isOidcCallback } from '~/helpers/keycloakCallback'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { public: config } = useRuntimeConfig()

  // Keep environment policy in the plugin so the helper stays a plain
  // cookie/JWT utility and cannot accidentally enable mock auth by itself.
  const isMockRuntime = Boolean(
    process.env.VITEST || import.meta.dev || process.env.TEST === 'true'
  )
  const shouldMock =
    isMockRuntime && (process.env.VITEST || hasMockAuthCookie())

  if (shouldMock) {
    nuxtApp.provide('keycloak', createMockKeycloak(config))
    return
  }

  const kc = new Keycloak({
    url: config.keycloakUrl,
    realm: config.keycloakRealm,
    clientId: config.keycloakClientId,
  })

  try {
    await kc.init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
      // On an auth-code callback, omit silentCheckSsoRedirectUri — keycloak-js
      // would use it as the redirect_uri in the token exchange, which mismatches
      // the URI Keycloak registered for that auth session and causes init to fail.
      ...(isOidcCallback(config)
        ? {}
        : {
            silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
          }),
    })

    if (
      kc.authenticated &&
      kc.tokenParsed?.realm_access?.roles?.includes('no_access')
    ) {
      kc.logout()
      return
    }
  } catch (error) {
    console.error('[keycloak] init failed:', error)
    console.error('[keycloak] location:', window.location.href)
    nuxtApp.provide('keycloak', null)
    return
  }

  nuxtApp.provide('keycloak', kc)
})
